function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCanFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash_can_full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    rx: 12,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M6.5 17A1.5 1.5 0 0 1 5 15.5v-10H4V4h4V3h4v1h4v1.5h-1v10a1.5 1.5 0 0 1-1.5 1.5zM8 14h1.5V7H8zm2.5 0H12V7h-1.5z",
    transform: "translate(2 2)",
    style: {
      fill: "#758091"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanFull);
export default __webpack_public_path__ + "static/media/trash_can_full.536cda862f4fe487c3efc5f750c0677a.svg";
export { ForwardRef as ReactComponent };